// jquery stuff initialized after jquery is ready

import './popup';
import './modules/offcanvas';
import './modules/scroll';
import './modules/comparison-hosts';
import './modules/flashes';
import './modules/masonry';
import './modules/gallery';
import './modules/content';
// import './modules/recent-purchase';


$(function() {
	$('.m-buybox').PluginBuybox();
	$('.m-switch').PluginSwitch();
	$('.m-countdown, .card-countdown-countdown').PluginCountdown2();
	$('.m-player').PluginPlayer();
	$('.m-section-projects').ProjectsPlayer();
	$('.table-custom-licenses [data-toggle="popover"]').popover({ html: true });

	// effects dropdown
	$('.navbar .dropdown-effects-toggle').click(function(e) {
		e.preventDefault();
		$('.dropdown-menu-effects').slideToggle(100);
	});

	// NETTE AJAX INIT
	$.nette.init();
	$.nette.ext('datalayer', {
		success: function(payload) {
			if (window.isProduction) {
				dataLayer.push(payload.dataLayer);
			} else {
				console.log('DATA LAYER');
				console.log(payload.dataLayer);
			}
		}
	}, {});

	// bs forms
	$('input[type=file]').on('change',function(){
		const files = [];
		for (let i = 0; i < $(this)[0].files.length; i++) {
			files.push($(this)[0].files[i].name);
		}
		$(this).next('.custom-file-label').html(files.join(', '));
	});

	// hide form table rows for hidden inputs. I don't think we need this anymore
	// $('[type=hidden]').parents('tr, .form-item').hide();


	// Open all external links in a new window
    $('a').not('[href*="mailto:"]').each(function () {
		var isInternalLink = new RegExp('/' + window.location.host + '/');
		if ( ! isInternalLink.test(this.href) ) {
			$(this).attr('target', '_blank');
		}
	});

	// register newsletter checkbox
	// automatically checks "accept newsletter" checkbox in register form if the user already has newsletter subscription
	$('#frm-registerForm-usr_email').on('change', function() {
		var $email = $(this);
		var email = $email.val();
		var $checkbox = $('#frm-registerForm-new_agree_processing');
		$.get('/newsletter/check', {email: email}, function(result) {
			$('.autocheck-message').remove();
			if (result === '1') {
				$checkbox.prop('checked', true);
				var $p = $checkbox.closest('p');
				$p.parent().children('.credits-note').remove();
				$p.append(
					$('<p/>', { class: 'autocheck-message green size-s'}).html('<b>' + email + ' is already in our newsletter database, so we checked this for you</b>')
				);
			}
		});
	}).trigger('change');

	// agree with processing text swap to include html link
	$('label[for=frm-newsletterForm-agree_processing], label[for=frm-form-agree_processing]').html('I accept your <a href="/about/privacy-policy" target="_blank">privacy policy</a>');

	$('.tutorial-playlist .video-item > div').each(function() {
		const $currentVideo = $(this).parent();
		const $container = $currentVideo.parent().parent();
		const offset = $currentVideo.position().top;
		const height = $currentVideo.height();
		$container.scrollTop(offset - height);
	});

	// sticky table headers
	const $stickyHeader = $('.sticky-header');
	const $topNavs = $('.top-navs');
	const $navbarThird = $('.navbar-third');

	if ($stickyHeader.length) {
		function updateStickyHeader() {
			const fixedOffset = $topNavs.hasClass('show-all') ? $topNavs.height() : $navbarThird.height();
			// console.log(fixedOffset, $topNavs.hasClass('show-all'));
			$stickyHeader.stickyTableHeaders({
				fixedOffset
			});
		}

		updateStickyHeader();
		$(window).on('scroll', function () {
			updateStickyHeader();
		});
	}

	$('.download-dropdown-info').tooltip({
		html: true,
		placement: 'bottom',
		template: '<div class="tooltip download-dropdown-tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',
	});

	$('.disable-transitions').removeClass('disable-transitions');

	const gallery = document.getElementById('detail-gallery');
	if (gallery) {
		lightGallery(gallery);
	}

	// fastspring checkout
	$('body').on('click', ".checkout-button", function (e) {
		console.log('click');
		if ($(this).hasClass('disabled')) return;

		console.log('checkout');
		fastspring.builder.checkout();
	});

});
